import React from 'react';
import { Counter } from '../Counter/Counter';
import styles from './VoteCounter.module.css';

export const VoteCounter = ({ total }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.title}>Проголосовало</div>
        <div className={styles.body}>
          <Counter total={total} />
        </div>
        <span className={styles.buble2}></span>
      </div>
    </div>
  );
};
